import moment from 'moment';

export default function toUTCDate(value, time = false, dateFormat = null) {
    if(!value) return null;
    const format = dateFormat != null ?  dateFormat : time ? "MM/DD/YYYY hh:mm a":"MM/DD/YYYY"; 
    var formatedDate = moment(value).utc().format(format);
    return formatedDate;
}